import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { deleteNode, updateAddNodes, updateNodeLabel } from "../nodes";

interface Room {
  name: string;
  id: number;
  roomtype?: string;
}

interface RoomState {
  notAdded: Room[];
  isAdded: Room[];
}

const initialState: RoomState = {
  notAdded: [],
  isAdded: [],
};

export const roomSlice = createSlice({
  name: "roomState",
  initialState,
  reducers: {
    updateDelete: (state, action: PayloadAction<number>) => {
      const roomIndex = state.isAdded.findIndex(
        (room) => room.id === action.payload
      );

      if (roomIndex !== -1) {
        const [room] = state.isAdded.splice(roomIndex, 1);
        state.notAdded.push(room);
      }
    },

    updateAdd: (state, action: PayloadAction<number>) => {
      const roomIndex = state.notAdded.findIndex(
        (room) => room.id === action.payload
      );

      if (roomIndex !== -1) {
        const [room] = state.notAdded.splice(roomIndex, 1);
        state.isAdded.push(room);
      }
    },

    resetRoomState: (state) => {
      state.isAdded = [];
      state.notAdded = [];
    },

    reset: () => initialState,
  },

  extraReducers: (builder) => {
    builder.addCase(deleteNode, (state, { payload }) => {
      let roomIndex = -1;

      state.isAdded.forEach((room, index) => {
        if (room.id === payload) {
          roomIndex = index;
        } else if (room.id > payload) {
          state.isAdded[index].id--;
        }
      });

      if (roomIndex !== -1) {
        state.isAdded.splice(roomIndex, 1);
      }

      roomIndex = -1;

      state.notAdded.forEach((room, index) => {
        if (room.id === payload) {
          roomIndex = index;
        } else if (room.id > payload) {
          state.notAdded[index].id--;
        }
      });

      if (roomIndex !== -1) {
        state.notAdded.splice(roomIndex, 1);
      }
    });

    builder.addCase(updateAddNodes, (state, { payload }) => {
      state.notAdded.push({
        id: payload.id,
        name: payload.label,
        roomtype: payload.roomtype || "Others",
      });
    });

    builder.addCase(updateNodeLabel, (state, { payload }) => {
      state.isAdded.forEach((room, index) => {
        if (room.id === payload.id) {
          state.isAdded[index].name = payload.label;
        }
      });

      state.notAdded.forEach((room, index) => {
        if (room.id === payload.id) {
          state.notAdded[index].name = payload.label;
        }
      });
    });
  },
});

export const { updateDelete, updateAdd, resetRoomState, reset } =
  roomSlice.actions;

export default roomSlice.reducer;

